import { render, staticRenderFns } from "./TripPoi.vue?vue&type=template&id=33053140&scoped=true&"
import script from "./TripPoi.vue?vue&type=script&lang=js&"
export * from "./TripPoi.vue?vue&type=script&lang=js&"
import style0 from "./TripPoi.vue?vue&type=style&index=0&id=33053140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33053140",
  null
  
)

export default component.exports